module.exports = __webpack_public_path__ + "static/img/company-logo.ca51ad6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/002-Topo-images/company-logo.svg
// module id = e6Ip
// module chunks = 1